import ArrowIcon from 'components/common/ArrowIcon';
import { Container } from 'components/common/CreditItemCard/components';
import FlexContainer from 'components/common/FlexContainer';

type Props = {
  sourceComponent: JSX.Element;
  targetComponent: JSX.Element;
};

export default function CreditItemCard(props: Props): JSX.Element {
  const { sourceComponent, targetComponent } = props;

  return (
    <Container className='credit-item-card'>
      <FlexContainer flex={2}>{sourceComponent}</FlexContainer>
      <ArrowIcon />
      <FlexContainer flex={3}>{targetComponent}</FlexContainer>
    </Container>
  );
}
